var React = require('react');

function Note (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1h8.5a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2zm0 8h3.5a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2zm0-4h4.5a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2zm14.337-5a.624.624 0 0 0-.447.19L7.634 7.316a.654.654 0 0 0-.164.288l-.948 3.575a.663.663 0 0 0 .163.632.62.62 0 0 0 .614.167l3.478-.975a.629.629 0 0 0 .28-.168l7.257-7.124a.66.66 0 0 0 .185-.46C18.5 1.455 17.084 0 15.337 0zM8.924 10.174a1.29 1.29 0 0 0-.648-.666l.37-1.394c.85.117 1.519.806 1.63 1.68l-1.352.38zm2.37-1.425a3.225 3.225 0 0 0-1.632-1.678l5.922-5.755c.853.115 1.524.805 1.635 1.682l-5.925 5.751z","fill":"#424242","fillRule":"evenodd"}));
}

Note.defaultProps = {"width":"19","height":"12","viewBox":"0 0 19 12"};

module.exports = Note;

Note.default = Note;
